import { createAnonAxios, ensureAnonSession } from "./vg2AnonAxios";

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
const api = createAnonAxios(API_V2);

export async function structuredRequestEnabled() {
  try {
    const { data } = await api.get("/structured-request/flag");
    return !!data.enabled;
  } catch {
    return false;
  }
}

export async function getStructuredRequest(journeyId) {
  await ensureAnonSession(API_V2);
  const { data } = await api.get(`/journeys/${journeyId}/structured-request`);
  return data;
}

export async function saveStructuredRequest(journeyId, body) {
  await ensureAnonSession(API_V2);
  const { data } = await api.put(`/journeys/${journeyId}/structured-request`, body);
  return data;
}

export async function resolvePendingRequest(journeyId, action) {
  await ensureAnonSession(API_V2);
  const { data } = await api.post(`/journeys/${journeyId}/structured-request/pending`, { action });
  return data;
}

export async function listPendingRequests() {
  const { data } = await api.get("/structured-request/pending");
  return data.items || [];
}

export async function setRequestAssumptions(journeyId, splitShareSell) {
  const { data } = await api.post(`/journeys/${journeyId}/structured-request/assumptions`, { split_share_sell: splitShareSell });
  return data;
}
